import { Close } from '@mui/icons-material'
import { IconButton, Snackbar } from '@mui/material'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import { SnackbarActions, SnackbarSelectors } from '../../store/snackbar'

export const CustomSnackbar = () => {
  const dispatch = useDispatch<AppDispatch>()
  const snackbarQueue = useSelector(SnackbarSelectors.getSnackbarQueue)
  const currentSnackbar = snackbarQueue[0]

  const handleClose = useCallback(
    (event?: React.SyntheticEvent | Event, reason?: string) => {
      if (reason === 'clickaway') {
        return
      }
      if (currentSnackbar?.options.key) {
        dispatch(SnackbarActions.removeSnackbar(currentSnackbar.options.key))
      }
    },
    [currentSnackbar, dispatch],
  )

  useEffect(() => {
    if (currentSnackbar) {
      const timer = setTimeout(() => {
        handleClose()
      }, currentSnackbar.options.autoHideDuration)

      return () => clearTimeout(timer)
    }
  }, [currentSnackbar, handleClose])

  if (!currentSnackbar) return null

  const action = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        <Close fontSize="small" />
      </IconButton>
    </>
  )

  return (
    <Snackbar
      open={true}
      message={currentSnackbar.message}
      anchorOrigin={currentSnackbar.options.anchorOrigin}
      autoHideDuration={currentSnackbar.options.autoHideDuration}
      onClose={handleClose}
      ContentProps={{
        sx: {
          backgroundColor:
            currentSnackbar.options.variant === 'success' ? 'success.main' : 'error.main',
          color: '#fff',
        },
      }}
      action={action}
    />
  )
}
